import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { type UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { bffDelete } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { Basket } from './model';

export const useDeleteCoupon = (): UseMutationResult<Basket, unknown, string> => {
    const { data } = useBasket();
    const authContext = useAuthContext();
    const queryClient = useQueryClient();

    return useMutation<Basket, unknown, string>({
        mutationFn: async (couponItemId: string) => {
            if (!isServer) await window.sfccSessionCreationPromise;
            const authData = await authContext.ready();
            return bffDelete(`/baskets/${data?.basketId}/coupons/${couponItemId}`, {
                basketCustomerId: data?.customerInfo?.customerId,
                accessToken: authData.access_token,
                customerId: authData.customer_id,
            });
        },
        onSuccess: (basket): void => {
            queryClient.setQueryData([BffQueryKey.BASKET], basket);
        },
    });
};
